import { z } from '../../zod';
import { ObjectIdStringValidationSchema } from '../../shared/ObjectId';

export const ThemeGetParamsValidationSchema = z.object({
  themeId: ObjectIdStringValidationSchema.meta({
    description: 'The theme ID, as returned by list or create.',
  }),
});
